import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import profile from "../../assets/profile.svg";
import logoutIcon from "../../assets/icon-logout.svg";
import { modalVariant } from "../Modal/Modalutils";
import { saveUserDetails, showModal } from "../../store/slices/common";
import { getSx } from "./style";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import GradingOutlinedIcon from "@mui/icons-material/GradingOutlined";
import BroadcastOnPersonalOutlinedIcon from "@mui/icons-material/BroadcastOnPersonalOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import MovieFilterOutlinedIcon from "@mui/icons-material/MovieFilterOutlined";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import routePaths from "../../router/route-paths";
// import { getProfile } from "../../http/auth";
import {
  deleteSessionData,
  deleteToken,
  getUserInfo,
} from "../../utils/auth-token-utils/cookie";
import { loginUser } from "../../comet-chat";

const sidebarItem = [
  {
    label: "Reports",
    path: routePaths.DASHBOARD,
    image: DashboardCustomizeIcon,
  },
  {
    label: "Retention Reports",
    path: routePaths.RETENTION,
    image: BarChartOutlinedIcon,
  },
  {
    label: "Active/Retention Users Visualization",
    path: routePaths.VISUALIZATION,
    image: ShowChartOutlinedIcon,
  },
  {
    label: "Profile Settings",
    path: routePaths.PROFILE_SETTINGS,
    image: SettingsIcon,
  },
  {
    label: "Broadcast Notifications",
    path: routePaths.BROADCAST_NOTIFICATIONS,
    image: BroadcastOnPersonalOutlinedIcon,
  },
  {
    label: "Manage Categories",
    path: routePaths.MANAGE_CATEGORIES,
    image: LocalAtmOutlinedIcon,
  },
  {
    label: "Manage App Data",
    path: routePaths.MANAGE_APP_DATA,
    image: MovieFilterOutlinedIcon,
  },
];

function Sidebar({ smScreen, mdScreen }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = getSx();

  const user = useSelector((state) => state.common.userDetails);

  useEffect(() => {
    getUserProfile();
  }, []);

  const logoutHandler = () => {
    dispatch(
      showModal({
        modalType: modalVariant.LOGOUT,
        resolveCallback: () => {
          dispatch(showModal(null));
          deleteSessionData();

          // in case remember me is checked
          deleteToken();
          navigate("/");
        },
        rejectCallback: () => {
          dispatch(showModal(null));
        },
      })
    );
  };

  const getUserProfile = async () => {
    try {
      const response = await getProfile();
      const user = response.data.data?.user;

      if (user) dispatch(saveUserDetails(user));
      const savedUser = getUserInfo();
      if (savedUser?.cometChat?.uid) await loginUser(savedUser, dispatch);
    } catch (error) {}
  };

  return (
    <Box width={{ xs: "80px", md: "260px" }} sx={classes.sidebarContainer}>
      <Box
        sx={
          mdScreen
            ? { ...classes.sidebarItems, padding: "10px 16px" }
            : classes.sidebarItems
        }
      >
        <img
          loading="lazy"
          src={profile}
          alt="Logo"
          style={classes.smallLogo}
        />
        <Box>
          <Typography sx={classes.profileName}>{user?.name}</Typography>
          <Typography sx={classes.email}>{user?.email}</Typography>
        </Box>
      </Box>
      <Box sx={classes.itemList}>
        <Box width={"100%"}>
          {sidebarItem.map((item) => {
            const Icon = item.image;

            return (
              <Box
                key={item.label}
                onClick={() => navigate(item.path)}
                sx={{
                  ...classes.sidebarItemContainer,
                  background:
                    window.location.pathname === item.path ? "#0832DE" : "",
                  padding: "18px",
                }}
              >
                <Box sx={classes.imageContainer}>
                  <Icon
                    sx={{
                      color:
                        window.location.pathname === item.path ? "#FFFFFF" : "",
                    }}
                  />
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    ...classes.sidebarLabel,
                    display: { xs: "none", md: "block" },
                    color:
                      window.location.pathname === item.path
                        ? "#FFFFFF"
                        : "#343434",
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
        <Box
          sx={
            smScreen
              ? { ...classes.logoutContainer, bottom: "0" }
              : classes.logoutContainer
          }
        >
          <Box sx={classes.logoutIcon} />
          <img src={logoutIcon} alt="Icon" onClick={() => logoutHandler()} />
          {!smScreen && (
            <Typography
              variant="body1"
              sx={classes.logoutText}
              onClick={() => logoutHandler()}
            >
              Logout
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default Sidebar;
